import {lazyRegister} from '@/Core/lazyRegister';
import {BaseApiFactory} from "@/Factories/BaseApiFactory";

export class DiscountRuleItemService {
    static $inject = ['BaseApiFactory'];

    constructor(private baseApiFactory: BaseApiFactory) {
    }

    public GetAllRuleItems(query: object) {
        return this.baseApiFactory.getData<any[]>('/api/DiscountRuleItem', query);
    }

    public getRuleItemById(id: number, cancelToken?: AbortSignal) {
        return this.baseApiFactory.getData<any>(`/api/DiscountRuleItem/${id}`, null, cancelToken);
    }

    public InsertRuleItem(values: any[]) {
        return this.baseApiFactory.post('/api/DiscountRuleItem', values);
    }

    public UpdateRuleItem(value: any) {
        return this.baseApiFactory.put('/api/DiscountRuleItem', value);
    }

    public DeleteRuleItem(id: string) {
        return this.baseApiFactory.delete('/api/DiscountRuleItem/' + id);
    }

    public RemoveDiscountRuleRelationItem(relationIds: number[]) {
        return this.baseApiFactory.delete('/api/DiscountRuleItem/RemoveDiscountRuleRelationItem', relationIds);
    }

    public GetDiscountRuleProducts(langCode: string, ruleItemId: string) {
        return this.baseApiFactory.get<any[]>('/api/DiscountRuleItem/GetDiscountRuleProducts?langCode=' + langCode + '&ruleItemId=' + ruleItemId);
    }
}

lazyRegister.service('DiscountRuleItemService', DiscountRuleItemService);
